import { Subject } from 'rxjs';
import { HubConnection } from '@microsoft/signalr';
import { buildHubConnection } from '../../components/CareManagement/CareManagementPanelHelpers';

type NoteTable = {
    id: string;
    caseId: string;
    cmEntityId: string;
    cmEntity: string | number;
    text: string;
    createBy: string;
    createdDate: string | Date;
    deletedBy: string;
    deletedDate: string | Date;
    updatedBy: string;
    updatedDate;
    categoryId: number;
    category: string;
    subcategoryId: number;
    subcategory: string;
    templateId?: number;
    templateName: string;
    TemplateValues: object;
    customTemplateText: string;
    audience: string | number;
    attachments: { fileId: string }[];
};
const updateOutreachTablesSubject = new Subject();
const updateCMAttachmentsTableSubject = new Subject();
const updateNotesTableSubject = new Subject<NoteTable>();
const updateNotesGridTabSubject = new Subject();
const engagementUpdatedSubject = new Subject();
const interactionsUpdatedSubject = new Subject();
const memberDetailsUpdateSubject = new Subject();
const memberContactsUpdateSubject = new Subject();
const taskUpdateSubject = new Subject();
const assessmentUpdateSubject = new Subject();
const carePlanUpdateSubject = new Subject();
const carePlanProblemNoteSubject = new Subject();
const attatchmentsUpdateSubject = new Subject();

export const updateAttachmentTabService = {
    get: () => attatchmentsUpdateSubject.asObservable(),
    update: (args) => {
        attatchmentsUpdateSubject.next(args);
    },
};

export const updateCarePlanTabService = {
    get: () => carePlanUpdateSubject.asObservable(),
    update: (args) => {
        carePlanUpdateSubject.next(args);
    },
};

export const updateCarePlanProblemNoteService = {
    get: () => carePlanProblemNoteSubject.asObservable(),
    update: (args) => {
        carePlanProblemNoteSubject.next(args);
    },
};

export const updateAssessmentTabService = {
    get: () => assessmentUpdateSubject.asObservable(),
    update: (args) => {
        assessmentUpdateSubject.next(args);
    },
};

export const updateTaskTabService = {
    get: () => taskUpdateSubject.asObservable(),
    update: (args) => {
        taskUpdateSubject.next(args);
    },
};

export const updateMemberContactsTabService = {
    get: () => memberContactsUpdateSubject.asObservable(),
    update: (args) => {
        memberContactsUpdateSubject.next(args);
    },
};

export const updateMemberDetailsTabService = {
    get: () => memberDetailsUpdateSubject.asObservable(),
    update: (args) => {
        memberDetailsUpdateSubject.next(args);
    },
};

export const updateNotesGridTabService = {
    get: () => updateNotesGridTabSubject.asObservable(),
    update: (args) => {
        updateNotesGridTabSubject.next(args);
    },
};

export const updateEngagementsGridService = {
    get: () => engagementUpdatedSubject.asObservable(),
    update: (args) => {
        engagementUpdatedSubject.next(args);
    },
};

export const interactionsService = {
    get: () => interactionsUpdatedSubject.asObservable(),
    update: (args) => {
        interactionsUpdatedSubject.next(args);
    },
};

export const updateOutreachTablesService = {
    get: () => updateOutreachTablesSubject.asObservable(),
    update: (args) => {
        updateOutreachTablesSubject.next(args);
    },
    getAttachments: () => updateCMAttachmentsTableSubject.asObservable(),
    updateAttachments: (args) => {
        updateCMAttachmentsTableSubject.next(args);
    },
    getNotes: () => updateNotesTableSubject.asObservable(),
    updateNotes: (args) => {
        updateNotesTableSubject.next(args);
    },
};

const updateMemberLettersGrid = new Subject();
export const updateMemberLettersGridService = {
    get: () => updateMemberLettersGrid.asObservable(),
    update: (args) => {
        updateMemberLettersGrid.next(args);
    },
};

const updateCMTeamGrid = new Subject();
export const updateCMTeamGridService = {
    get: () => updateCMTeamGrid.asObservable(),
    update: (memberId) => {
        updateCMTeamGrid.next(memberId);
    },
};

let hubConectionCM: HubConnection;
const createHubConnection = new Subject();
const getConnectionsSubject = new Subject();
const notificationSubject = new Subject();
const messageCMSubject = new Subject();

const bindNotificationStream = (connection: HubConnection) => {
    connection.on(
        'Notification',
        (message: any, memberId: any, addOrRemove: any, triggerAddOrRemove: any, providerName: any) => {
            const notificationObject = {
                message,
                memberId,
                addOrRemove,
                triggerAddOrRemove,
                providerName,
            };

            notificationSubject.next(notificationObject);
        },
    );
};

const bindMessageStream = (connection: HubConnection) => {
    connection.on('Message', (message: any, member: any, status: any, tabId: any) => {
        const messageObject = {
            message,
            member,
            status,
            tabId,
        };
        messageCMSubject.next(messageObject);
    });
};

export const createHubConnectionService = {
    next: (hubPath: string) => {
        hubConectionCM = buildHubConnection(hubPath);

        hubConectionCM
            .start()
            .then(() => {
                hubConectionCM.invoke('GetConnections').then((response) => {
                    if (response) {
                        getConnectionsSubject.next(response);
                    }
                });
            })
            .catch((err) => console.log(err));

        bindNotificationStream(hubConectionCM);
        bindMessageStream(hubConectionCM);
    },
    get$: () => createHubConnection.asObservable(),
    getHubConnection: () => hubConectionCM,
    invokeSaveConnection: (tabId: string, tabIndex: number) => {
        hubConectionCM.invoke('SaveConnectionAsync', tabId, tabIndex);
    },
    invokeProvidersOnMember: (memberId: string) => {
        hubConectionCM.invoke('GetProvidersOnThisMember', memberId).then((response) => {
            return response;
        });
    },
    invokeFreeConnection: (memberId: string) => {
        hubConectionCM.invoke('FreeConnectionAsync', memberId);
    },
    closeAllStreams: () => {
        hubConectionCM.off('Notification');
        hubConectionCM.off('Message');
        hubConectionCM.stop();
    },
};
export const notificationSubjectService = {
    get$: () => notificationSubject.asObservable(),
};

export const messageCMSubjectService = {
    get$: () => messageCMSubject.asObservable(),
};
